import { ContainerSizeDefaults } from "@/common/constants";
import { makeStyles } from "@fluentui/react-components";

export const useQueueFilterStyle = makeStyles({ 
    menuPopover: {
        maxWidth: `${ContainerSizeDefaults.InteractionPanelWidth - 8}px`
    }
});